export const SLASH_SUGGESTION_NAV_KEYS = [
  'ArrowDown',
  'ArrowUp',
  'ArrowRight',
  'ArrowLeft',
  'Enter',
  'Tab',
  'Escape'
];

export const shouldConsumeSlashSuggestionNavKey = ({
  dismissed,
  key
}: {
  dismissed: boolean;
  key: string;
}): boolean => !dismissed && SLASH_SUGGESTION_NAV_KEYS.includes(key);
